import { combineReducers } from 'redux'

import abilityStatusReducer from '../../containers/AbilityStatusSection/AbilityStatusSection.reducer'
import authorizationProviderReducer from '../../containers/AuthorizationProvider/AuthorizationProvider.reducer'
import basicSellerInformationReducer from '../../containers/BasicSellerInformationSection/BasicSellerInformationSection.reducer'
import companyAdministrationReducer from '../../containers/CompanyAdministrationSection/CompanyAdministrationSection.reducer'
import companyContactInformationReducer from '../../containers/CompanyContactSection/CompanyContactSection.reducer'
import contractualBehaviorReducer from '../../containers/ContractualBehavior/ContractualBehavior.reducer'
import enrollmentCertificateReducer from '../../containers/EnrollmentCertificateSection/EnrollmentCertificateSection.reducer'
import finalBeneficiarySectionReducer from '../../containers/FinalBeneficiarySection/FinalBeneficiarySection.reducer'
import financialSuitabilityReducer from '../../containers/FinancialSuitabilitySection/FinancialSuitabilitySection.reducer'
import frameworkAgreementSectionReducer from '../../containers/FrameworkAgreementSection/FrameworksAgreementSection.reducer'
import historicalContractsReducer from '../../containers/HistoricalContracts/HistoricalContracts.reducer'
import historicalSanctionsListReducer from '../../containers/HistoricalSanctionsList/HistoricalSanctionsList.reducer'
import legalDocumentsReducer from '../../containers/LegalDocumentation/LegalDocumentationSection.reducer'
import legalSuitabilityReducer from '../../containers/LegalSuitabilitySection/LegalSuitabilitySection.reducer'
import partnershipGridSectionReducer from '../../containers/PartnershipGridSection/PartnershipGridSection.reducer'
import recaptchaReducer from '../../containers/Recaptcha/recaptcha.reducer'
import relatedCompanySectionReducer from '../../containers/RelatedCompanySection/RelatedCompanySection.reducer'
import reviewedContractsTableReducer from '../../containers/ReviewedContractsTable/ReviewedContractsTable.reducer'
import sanctionReducer from '../../containers/Sanction/Sanction.reducer'
import siiInformationReducer from '../../containers/SiiInformationSection/SiiInformationSection.reducer'
import stampsSectionReducer from '../../containers/StampsSection/StampsSection.reducer'
import summarySectionReducer from '../../containers/SummarySection/SummarySection.reducer'
import taxAnnotationsReducer from '../../containers/TaxAnnotationsSection/TaxAnnotationsSection.reducer'
import technicalSuitabilityReducer from '../../containers/TechnicalSuitabilitySection/TechnicalSuitabilitySection.reducer'
import temporaryUnionsReducer from '../../containers/TemporaryUnionsSection/TemporaryUnionsSection.reducer'
import middlewareRouteReducer from '../../containers/MiddlewareRoute/MiddlewareRoute.reducer'
import uniqueSellerReducer from '../../containers/UniqueSellersSection/UniqueSellersSection.reducer'
import workRegisterReducer from '../../containers/WorkRegister/WorkRegister.reducer'

export default combineReducers({
  abilityStatus: abilityStatusReducer,
  authorizationProvider: authorizationProviderReducer,
  basicSellerInformation: basicSellerInformationReducer,
  companyAdministration: companyAdministrationReducer,
  companyContactInformation: companyContactInformationReducer,
  contractualBehavior: contractualBehaviorReducer,
  enrollmentCertificate: enrollmentCertificateReducer,
  finalBeneficiaries: finalBeneficiarySectionReducer,
  financialSuitability: financialSuitabilityReducer,
  frameworkAgreementSection: frameworkAgreementSectionReducer,
  historicalContracts: historicalContractsReducer,
  historicalSanctionsList: historicalSanctionsListReducer,
  legalDocuments: legalDocumentsReducer,
  legalSuitability: legalSuitabilityReducer,
  partnershipGridSection: partnershipGridSectionReducer,
  recaptcha: recaptchaReducer,
  relatedCompanies: relatedCompanySectionReducer,
  reviewedContracts: reviewedContractsTableReducer,
  sanction: sanctionReducer,
  siiInformation: siiInformationReducer,
  stamps: stampsSectionReducer,
  summarySection: summarySectionReducer,
  taxAnnotations: taxAnnotationsReducer,
  technicalSuitability: technicalSuitabilityReducer,
  temporaryUnions: temporaryUnionsReducer,
  uniqueSeller: uniqueSellerReducer,
  middlewareRoute: middlewareRouteReducer,
  workRegister: workRegisterReducer
})
